import { parsePhoneNumber, US_PHONE_NUMBER_DIGIT_LIMIT } from './phoneUtils';

export const getInitials = (firstName: string, lastName: string) => {
  return `${firstName[0]}${lastName[0]}`.toUpperCase();
};

export const normalizePhoneNumberForCognito = (phoneNumber: string) => {
  const digits = parsePhoneNumber(phoneNumber);

  if (digits.length === US_PHONE_NUMBER_DIGIT_LIMIT) {
    return `+1${digits}`;
  }

  return '';
};
